import React from "react";
import Navbar from "./Navbar";
import Introduction from "./Introduction";
import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import FeatureDisplay from "./FeatureDisplay";
import ClientsSection from "./ClientsSection";
import AgriTechSection from "./AgriTechSection";
import BackgroundCircles from "./BackgroundCircles";
import Footer from "./Footer";

const LandingDesktop = () => {
  return (
    <>
      <Box
        sx={{
          margin: "auto",
          maxWidth: "1180px",
          padding: "0 4.5rem",
        }}
      >
        <BackgroundCircles />
        <Navbar />
        <HeroSection />
        <ClientsSection />
      </Box>
      <Introduction />
      <Box
        sx={{
          margin: "auto",
          maxWidth: "1180px",
          padding: "0 4.5rem",
        }}
      >
        <AgriTechSection />
        <FeatureDisplay />
      </Box>
      <Footer />
    </>
  );
};

export default LandingDesktop;
